import { from, Observable, of } from 'rxjs';

export class PassportNumber {
  private internalSeries: string;
  private internalNumber: string;

  private constructor(series: string, number: string) {
    this.internalSeries = series;
    this.internalNumber = number;
  }

  static fromString(serialNumber: string): PassportNumber {
    const isnum = (s: string) => /^\d+$/.test(s);
    if (!isnum(serialNumber) || serialNumber.length !== 9) {
      throw new Error('incorrect serialNumber');
    }
    return new PassportNumber(serialNumber.slice(0, 2), serialNumber.slice(2));
  }

  static fromSeriesAndNumber(series: string, number: string): PassportNumber {
    const isnum = (s: string) => /^\d+$/.test(s);
    if (!isnum(series) || series.length !== 2) {
      throw new Error('incorrect series');
    }
    if (!isnum(number) || number.length !== 7) {
      throw new Error('incorrect number');
    }
    return new PassportNumber(series, number);
  }

  get SerialNumber() {
    return this.internalSeries + this.internalNumber;
  }

  get Number() {
    return this.internalNumber;
  }

  get Series() {
    return this.internalSeries;
  }
}

export abstract class PassportsStore {
  getGrantedPassports(): Observable<PassportNumber> {
    return from([]);
  }

  removeGrantedPassport(number: PassportNumber): Observable<boolean> {
    return of(true);
  }

  saveGrantedPassport(number: PassportNumber): Observable<boolean> {
    return of(true);
  }
}
